import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Input,
  Button,
  Heading,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Select,
  Checkbox,
  VStack,
  Text,
  FormErrorMessage,
  Image,
  HStack,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import CustomDatePicker from "./CustomDatePicker"; // นำเข้า CustomDatePicker
import { StandardPageTitle, StandardHeader } from "../themes/StandardHeader";
import ApiService from "../services/ApiService"; // นำเข้า ApiService
import { AuthContext } from "../context/AuthContext"; // เพิ่มการ import AuthContext
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressCard,
  faLocationDot,
  faImage,
  faUser,
  faHouseChimney,
  faHatCowboy,
} from "@fortawesome/free-solid-svg-icons";
import { min } from "date-fns";

// เพิ่ม prop isEditMode เพื่อใช้ตรวจสอบว่าเป็นโหมดแก้ไขหรือไม่
const RegistrationFarmer = ({ isEditMode = false }) => {
  const navigate = useNavigate();
  const { sessionId } = useContext(AuthContext) || {}; // ดึง sessionId จาก AuthContext
  const [formData, setFormData] = useState({
    FarmerID: "",
    FirstName: "",
    LastName: "",
    FirstName2: "",
    LastName2: "",
    IDCard: "",
    Gender: "M",
    BirthDate: null,
    AddressNo: "",
    AddressMoo: "",
    AddressRoad: "",
    AddressSubdistrict: "",
    AddressDistrict: "",
    AddressProvince: "",
    AddressZipcode: "",
    Email: "",
    Phone: "",
    Address: "",
    ProfileImage: null,
    Remark: "",
    Status: "Active",
    Password: "",
    ConfirmPassword: "",

    // State สำหรับข้อมูลปศุสัตว์
    FarmName: "",
    // เปลี่ยน FarmAddress เป็น Object เพื่อเก็บรายละเอียด
    FarmAddress: {
      AddressNo: "",
      AddressMoo: "",
      AddressRoad: "",
      AddressSubdistrict: "",
      AddressDistrict: "",
      AddressProvince: "",
      AddressZipcode: "",
    },
    Livestock: {
      BeefCattle: 0,
      DairyCattle: 0,
      Buffalo: 0,
      Swine: 0,
      Chicken: 0,
      Duck: 0,
      Goat: 0,
      Sheep: 0,
      Quail: 0,
      Dog: 0,
      Cat: 0,
      Other: 0,
    },
  });
  const [errors, setErrors] = useState({});
  const [privacyChecked, setPrivacyChecked] = useState(false);
  // State สำหรับ checkbox 'ใช้ที่อยู่เดียวกัน'
  const [useSameAddress, setUseSameAddress] = useState(false);

  // useEffect สำหรับจัดการการคัดลอกที่อยู่
  useEffect(() => {
    if (useSameAddress) {
      setFormData((prev) => ({
        ...prev,
        FarmAddress: {
          AddressNo: prev.AddressNo,
          AddressMoo: prev.AddressMoo,
          AddressRoad: prev.AddressRoad,
          AddressSubdistrict: prev.AddressSubdistrict,
          AddressDistrict: prev.AddressDistrict,
          AddressProvince: prev.AddressProvince,
          AddressZipcode: prev.AddressZipcode,
        },
      }));
    } else {
      // Optional: clear fields when unchecked
      setFormData((prev) => ({
        ...prev,
        FarmAddress: {
          AddressNo: "",
          AddressMoo: "",
          AddressRoad: "",
          AddressSubdistrict: "",
          AddressDistrict: "",
          AddressProvince: "",
          AddressZipcode: "",
        },
      }));
    }
  }, [
    useSameAddress,
    formData.AddressNo,
    formData.AddressMoo,
    formData.AddressRoad,
    formData.AddressSubdistrict,
    formData.AddressDistrict,
    formData.AddressProvince,
    formData.AddressZipcode,
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validateField(name, value);
  };

  // Handler สำหรับอัปเดตข้อมูลที่อยู่ของฟาร์ม
  const handleFarmAddressChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      FarmAddress: {
        ...prev.FarmAddress,
        [name]: value,
      },
    }));
  };

  const handleLivestockChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      Livestock: {
        ...prev.Livestock,
        [name]: value,
      },
    }));
  };

  const handleDateChange = (date) => {
    setFormData({ ...formData, BirthDate: date });
    validateField("BirthDate", date);
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFormData({ ...formData, ProfileImage: reader.result });
        };
        reader.readAsDataURL(file);
      }
    },
  });

  const validateField = (name, value) => {
    let newErrors = { ...errors };
    switch (name) {
      case "IDCard":
        if (!/^\d{13}$/.test(value)) {
          newErrors[name] = "เลขบัตรประชาชนต้องเป็นตัวเลข 13 หลัก";
        } else {
          delete newErrors[name];
        }
        break;
      case "Email":
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          newErrors[name] = "รูปแบบอีเมลไม่ถูกต้อง";
        } else {
          delete newErrors[name];
        }
        break;
      case "BirthDate":
        if (!value) {
          newErrors[name] = "กรุณาเลือกวันเกิด";
        } else {
          delete newErrors[name];
        }
        break;
      case "Password":
        if (!value) {
          newErrors[name] = "กรุณากรอกรหัสผ่าน";
        } else if (value.length < 6) {
          newErrors[name] = "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร";
        } else {
          delete newErrors[name];
        }
        break;
      case "ConfirmPassword":
        if (!value) {
          newErrors[name] = "กรุณายืนยันรหัสผ่าน";
        } else if (value !== formData.Password) {
          newErrors[name] = "รหัสผ่านไม่ตรงกัน";
        } else {
          delete newErrors[name];
        }
        break;
      default:
        if (
          !value &&
          [
            "FirstName",
            "LastName",
            "IDCard",
            "BirthDate",
            "Email",
            "Phone",
          ].includes(name)
        ) {
          newErrors[name] = "กรุณากรอกข้อมูล";
        } else {
          delete newErrors[name];
        }
    }
    setErrors(newErrors);
  };

  useEffect(() => {
    if (!isEditMode) {
      setFormData((prev) => ({ ...prev, FarmerID: prev.IDCard }));
    }
  }, [formData.IDCard, isEditMode]);

  const isFormValid = () => {
    return (
      formData.FirstName.trim() !== "" &&
      formData.LastName.trim() !== "" &&
      formData.IDCard.trim() !== "" &&
      /^\d{13}$/.test(formData.IDCard) &&
      formData.BirthDate !== null &&
      formData.Email.trim() !== "" &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.Email) &&
      formData.Phone.trim() !== "" &&
      formData.Password.trim() !== "" &&
      formData.ConfirmPassword === formData.Password &&
      Object.keys(errors).length === 0 &&
      privacyChecked
    );
  };

  const handleSubmit = async () => {
    if (!isFormValid()) {
      alert("กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง");
      return;
    }

    const submitData = {
      ...formData,
      BirthDate: formData.BirthDate,
      ProfileImage: formData.ProfileImage || "",
    };

    try {
      const data = await ApiService({
        method: "POST",
        url: "/registerFarmer",
        data: submitData,
        sessionId: sessionId,
      });
      alert("ลงทะเบียนสำเร็จ!");
      navigate("/home");
    } catch (error) {
      alert("เกิดข้อผิดพลาดในการลงทะเบียน: " + error.message);
    }
  };

  const livestockTypes = [
    { key: "BeefCattle", label: "โคเนื้อ" },
    { key: "DairyCattle", label: "โคนม" },
    { key: "Buffalo", label: "กระบือ" },
    { key: "Swine", label: "สุกร" },
    { key: "Chicken", label: "ไก่" },
    { key: "Duck", label: "เป็ด" },
    { key: "Goat", label: "แพะ" },
    { key: "Sheep", label: "แกะ" },
    { key: "Quail", label: "นกกระทา" },
    { key: "Dog", label: "สุนัข" },
    { key: "Cat", label: "แมว" },
    { key: "Other", label: "สัตว์อื่นๆ" },
  ];

  const farmAddressFields = [
    { key: "AddressNo", label: "เลขที่" },
    { key: "AddressMoo", label: "หมู่" },
    { key: "AddressRoad", label: "ถนน" },
    { key: "AddressSubdistrict", label: "ตำบล" },
    { key: "AddressDistrict", label: "อำเภอ" },
    { key: "AddressProvince", label: "จังหวัด" },
    { key: "AddressZipcode", label: "รหัสไปรษณีย์" },
  ];

  return (
    // <-- ADJUSTED: ปรับ p และ m ให้ responsive
    <Box p={{ base: 4, md: 6 }} m={{ base: 2, md: 6 }} borderWidth={1} borderRadius="lg" boxShadow="lg">
      <StandardPageTitle title="ลงทะเบียนเกษตรกร / ประชาชนทั่วไป" />

      {/* Box 1: ข้อมูลทั่วไป */}
      <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
        <StandardHeader
          title="ข้อมูลทั่วไป"
          bgColor="iTeal.600"
          icon={faAddressCard}
        />
        {/* <-- ADJUSTED: ทำให้ Grid เป็น 1 คอลัมน์บนมือถือ และ 3 คอลัมน์บนจอใหญ่ */}
        <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6} p={5}>
          {["FirstName", "LastName", "IDCard", "Gender", "BirthDate"].map(
            (key) => (
              <GridItem colSpan={1} key={key}>
                <FormControl isRequired isInvalid={!!errors[key]}>
                  <FormLabel fontSize="xl" color="gray">
                    {key === "FirstName"
                      ? "ชื่อ"
                      : key === "LastName"
                      ? "นามสกุล"
                      : key === "IDCard"
                      ? "เลขบัตรประชาชน"
                      : key === "Gender"
                      ? "เพศ"
                      : "วันเกิด (วัน/เดือน/ปี พ.ศ.)"}
                    <Text as="span" color="red">
                      {" "}
                      *
                    </Text>
                  </FormLabel>
                  {key === "Gender" ? (
                    <Select
                      name={key}
                      value={formData[key]}
                      onChange={handleInputChange}
                      colorScheme="iTeal"
                    >
                      <option value="M">ชาย</option>
                      <option value="F">หญิง</option>
                    </Select>
                  ) : key === "BirthDate" ? (
                    <CustomDatePicker
                      name={key}
                      value={formData.BirthDate}
                      onChange={handleInputChange}
                      colorScheme="iTeal"
                    />
                  ) : (
                    <Input
                      name={key}
                      value={formData[key]}
                      onChange={handleInputChange}
                      readOnly={key === "FarmerID"}
                      colorScheme="iTeal"
                    />
                  )}
                  <FormErrorMessage>{errors[key]}</FormErrorMessage>
                </FormControl>
              </GridItem>
            )
          )}
        </Grid>
      </Box>

      {/* Box 2: ข้อมูลการติดต่อ */}
      <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
        <StandardHeader
          title="ข้อมูลการติดต่อ"
          bgColor="iBlue.600"
          icon={faLocationDot}
        />
        {/* <-- ADJUSTED: ทำให้ Grid เป็น 1 คอลัมน์บนมือถือ และ 3 คอลัมน์บนจอใหญ่ */}
        <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6} p={5}>
          {[
            "AddressNo",
            "AddressMoo",
            "AddressRoad",
            "AddressSubdistrict",
            "AddressDistrict",
            "AddressProvince",
            "AddressZipcode",
            "Email",
            "Phone",
          ].map((key) => (
            <GridItem colSpan={1} key={key}>
              <FormControl
                isRequired={["Email", "Phone"].includes(key)}
                isInvalid={!!errors[key]}
              >
                <FormLabel fontSize="xl" color="gray">
                  {key === "Email"
                    ? "อีเมลล์"
                    : key === "Phone"
                    ? "เบอร์โทรศัพท์"
                    : key === "AddressNo"
                    ? "เลขที่"
                    : key === "AddressMoo"
                    ? "หมู่"
                    : key === "AddressRoad"
                    ? "ถนน"
                    : key === "AddressSubdistrict"
                    ? "ตำบล"
                    : key === "AddressDistrict"
                    ? "อำเภอ"
                    : key === "AddressProvince"
                    ? "จังหวัด"
                    : key === "AddressZipcode"
                    ? "รหัสไปรษณีย์"
                    : "ที่อยู่"}
                  {["Email", "Phone"].includes(key) ? (
                    <Text as="span" color="red">
                      {" "}
                      *
                    </Text>
                  ) : null}
                </FormLabel>
                <Input
                  name={key}
                  value={formData[key]}
                  onChange={handleInputChange}
                  colorScheme="iBlue"
                />
                <FormErrorMessage>{errors[key]}</FormErrorMessage>
              </FormControl>
            </GridItem>
          ))}
        </Grid>
      </Box>

      {/* Box 3: ข้อมูลปศุสัตว์ */}
      <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
        <StandardHeader
          title="ข้อมูลปศุสัตว์"
          bgColor="iGreen.600"
          icon={faHatCowboy}
        />
        <VStack spacing={5} p={5} align="flex-start">
          {/* <-- ADJUSTED: Grid ของชื่อฟาร์ม */}
          <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6} w="100%">
            {/* <-- ADJUSTED: ทำให้ colSpan responsive */}
            <GridItem colSpan={{ base: 1, lg: 2 }}>
              <FormControl>
                <FormLabel fontSize="xl" color="gray">
                  ชื่อฟาร์ม / ชื่อบริษัท
                </FormLabel>
                <Input
                  name="FarmName"
                  value={formData.FarmName}
                  onChange={handleInputChange}
                  colorScheme="iGreen"
                />
              </FormControl>
            </GridItem>
          </Grid>

          <FormControl>
            <FormLabel fontSize="xl" color="gray">
              สถานที่ตั้ง
            </FormLabel>
            <Checkbox
              isChecked={useSameAddress}
              onChange={(e) => setUseSameAddress(e.target.checked)}
              colorScheme="iGreen"
              size="lg"
            >
              ใช้ที่อยู่เดียวกับข้อมูลการติดต่อ
            </Checkbox>
          </FormControl>

          {/* <-- ADJUSTED: ทำให้ Grid เป็น 1 คอลัมน์บนมือถือ และ 3 คอลัมน์บนจอใหญ่ */}
          <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6} w="100%">
            {farmAddressFields.map((field) => (
              <GridItem colSpan={1} key={field.key}>
                <FormControl>
                  <FormLabel color="gray.600">{field.label}</FormLabel>
                  <Input
                    name={field.key}
                    value={formData.FarmAddress[field.key]}
                    onChange={handleFarmAddressChange}
                    isDisabled={useSameAddress} // Disable if checkbox is checked
                    colorScheme="iGreen"
                  />
                </FormControl>
              </GridItem>
            ))}
          </Grid>

          <FormControl>
            <FormLabel fontSize="xl" color="gray" mb={4}>
              จำนวนปศุสัตว์
            </FormLabel>
            {/* <-- ADJUSTED: ทำให้ Grid เป็น 1, 2, และ 4 คอลัมน์ตามขนาดจอ */}
            <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", xl: "repeat(4, 1fr)" }} gap={5}>
              {livestockTypes.map((animal) => (
                <GridItem key={animal.key}>
                  <FormControl>
                    <FormLabel color="gray.600">{animal.label}</FormLabel>
                    <NumberInput
                      min={0}
                      value={formData.Livestock[animal.key]}
                      onChange={(valueString) =>
                        handleLivestockChange(
                          animal.key,
                          parseInt(valueString) || 0
                        )
                      }
                    >
                      <NumberInputField colorScheme="iGreen" />
                      <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                      </NumberInputStepper>
                    </NumberInput>
                  </FormControl>
                </GridItem>
              ))}
            </Grid>
          </FormControl>
        </VStack>
      </Box>

      {/* Box 4: รูปโปรไฟล์ (แสดงเฉพาะโหมดแก้ไข) */}
      {isEditMode && (
        <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
          <StandardHeader
            title="รูปโปรไฟล์"
            bgColor="iOrange.600"
            icon={faImage}
          />
          <Box
            {...getRootProps()}
            borderWidth={2}
            borderStyle="dashed"
            borderRadius="md"
            // <-- ADJUSTED: ปรับความกว้างให้ responsive
            w={{ base: "100%", md: "70%" }}
            p={5}
            textAlign="center"
            cursor="pointer"
            mt={5}
          >
            <Input {...getInputProps()} colorScheme="iGreen" />
            {formData.ProfileImage ? (
              <Image
                src={formData.ProfileImage}
                alt="Profile Preview"
                maxH="200px"
                mx="auto"
              />
            ) : (
              <Text h={20}>ลากและวางรูปภาพที่นี่ หรือคลิกเพื่อเลือกไฟล์</Text>
            )}
          </Box>
        </Box>
      )}

      {/* Box 5: ชื่อผู้ใช้และรหัสผ่าน */}
      <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
        <StandardHeader
          title="ชื่อผู้ใช้และรหัสผ่าน"
          bgColor="iPurple.600"
          icon={faUser}
        />
        {/* <-- ADJUSTED: ทำให้ Grid เป็น 1 คอลัมน์บนมือถือ และ 3 คอลัมน์บนจอใหญ่ */}
        <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6} p={5}>
          <GridItem>
            <FormControl isRequired isInvalid={!!errors["Email"]}>
              <FormLabel fontSize="xl" color="gray">
                ชื่อผู้ใช้ (อีเมลล์){" "}
                <Text as="span" color="red">
                  {" "}
                  *
                </Text>
              </FormLabel>
              <Input
                name="Email"
                value={formData.Email}
                onChange={handleInputChange}
                isDisabled={isEditMode}
                colorScheme="iPurple"
              />
              <FormErrorMessage>{errors["Email"]}</FormErrorMessage>
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired isInvalid={!!errors["Password"]}>
              <FormLabel fontSize="xl" color="gray">
                รหัสผ่าน{" "}
                <Text as="span" color="red">
                  {" "}
                  *
                </Text>
              </FormLabel>
              <Input
                name="Password"
                type="password"
                value={formData.Password}
                onChange={handleInputChange}
                colorScheme="iPurple"
              />
              <FormErrorMessage>{errors["Password"]}</FormErrorMessage>
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired isInvalid={!!errors["ConfirmPassword"]}>
              <FormLabel fontSize="xl" color="gray">
                ยืนยันรหัสผ่าน{" "}
                <Text as="span" color="red">
                  {" "}
                  *
                </Text>
              </FormLabel>
              <Input
                name="ConfirmPassword"
                type="password"
                value={formData.ConfirmPassword}
                onChange={handleInputChange}
                colorScheme="iPurple"
              />
              <FormErrorMessage>{errors["ConfirmPassword"]}</FormErrorMessage>
            </FormControl>
          </GridItem>
        </Grid>
      </Box>

      {/* <-- ADJUSTED: ปรับ p และ m ให้เล็กลง */}
      <Box p={{ base: 2, md: 5 }} m={{ base: 2, md: 5 }}>
        <Checkbox
          mt={3}
          onChange={(e) => setPrivacyChecked(e.target.checked)}
          size="lg"
          colorScheme="iOrange"
        >
          ฉันได้อ่านนโยบายความเป็นส่วนตัวและเข้าใจนโยบายความเป็นส่วนตัวของเราแล้ว
          และยอมรับเงื่อนไขการใช้งาน รวมถึงนโยบายความเป็นส่วนตัวของเรา
          และยอมรับการใช้งานของคุกกี้ และเทคโนโลยีต่างๆ ที่เกี่ยวข้อง
        </Checkbox>
      </Box>

      {/* <-- ADJUSTED: ปรับ p และ m ให้เล็กลง */}
      <Box p={{ base: 2, md: 5 }} m={{ base: 2, md: 5 }}>
        <Button
          colorScheme="blue"
          mt={5}
          onClick={handleSubmit}
          isDisabled={!isFormValid()}
          // <-- ADJUSTED: ทำให้ปุ่มเต็มความกว้างบนมือถือ
          w={{ base: "full", md: "auto" }}
        >
          {isEditMode ? "บันทึกการเปลี่ยนแปลง" : "ลงทะเบียน"}
        </Button>
      </Box>
    </Box>
  );
};

export default RegistrationFarmer;